import { isEqualFieldValues } from "./isEqualFieldValues";

const isFormRecord = (
  value: Record<string, unknown> | null | undefined,
): value is Record<string, unknown> => value !== null && value !== undefined;

/** Сравнение всех полей формы с учётом нормализации пустых строковых значений. */
export const isEqualFormValues = (
  a: Record<string, unknown> | null | undefined,
  b: Record<string, unknown> | null | undefined,
): boolean => {
  if (!isFormRecord(a) && !isFormRecord(b)) {
    return true;
  }
  if (!isFormRecord(a) || !isFormRecord(b)) {
    return false;
  }
  const allKeys = Array.from(new Set([...Object.keys(a), ...Object.keys(b)]));
  return !allKeys.find((key) => !isEqualFieldValues(a[key], b[key]));
};
